import EmployeeInfo from "../../employeeInfo/employeeInfoCM"

const EmploDeReport=({})=>{
    return <EmployeeInfo 
    config={{
       personalInfo: true,
        title: "Employee Details Report",
        downloadIcon: true,
        hideSeachField: true,
        onclickFalse: true,
        // reportType: "Employee Detail Report",
      }}
    gridSize={{
        sm:6,
        xs:12
      }} />
}

export default EmploDeReport